import { Navigate, Route, Routes } from "react-router-dom";

import { SubNav } from "@/app/Shell";
import { PlansMatrixPage } from "@/modules/plans/MatrixPage";

/** Plans module: what each subscription tier includes, crossed with who the
 *  user is (D-77 — Orbit is authoritative for what its own features MEAN).
 *
 *  NO GATE. Plans shows the PRODUCT, not anybody's data: no company, no asset
 *  and no person appears on it. A customer deciding whether to upgrade must be
 *  able to read what they would be buying.
 *
 *  ONE tab today, and still a module: every other surface in the console is
 *  reached the same way, and a page that skips the shell reads as a different
 *  kind of thing than it is. A second tab lands here, not in a rewrite.
 */
export function PlansModule() {
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/plans" tabs={[{ path: "matrix", label: "Plan × Role" }]} />
      </div>
      <Routes>
        <Route path="matrix" element={<PlansMatrixPage />} />
        <Route path="*" element={<Navigate to="matrix" replace />} />
      </Routes>
    </>
  );
}
